import { WidgetIDs } from 'extensions/widget/models/widget-ids';
import footTrafficPreview from 'features/recovery-dashboard/common/assets/foot_traffic_widget_preview.png';
import recoveryMapPreview from 'features/recovery-dashboard/common/assets/recovery_map_widget_preview.png';
import retailPreview from 'features/recovery-dashboard/common/assets/retail_recovery_widget_preview.png';
import tourismPreview from 'features/recovery-dashboard/common/assets/tourism_recovery_widget_preview.png';
import zipcodesPreview from 'features/recovery-dashboard/common/assets/zipcodes_map_widget_preview.png';

export type FormType =
    | 'Recovery Dashboard - Get Full Report'
    | 'Recovery Dashboard - Weekly Updates'
    | 'Recovery Dashboard - Get Widget'
    | 'Recovery Dashboard - Workplace Update'
    | 'Recovery Dashboard - Add District'
    | 'Recovery Dashboard - Region Coming Soon';

export type FormBaseFields = 'form_type';

export type UserInfoFields = 'firstname' | 'lastname' | 'company' | 'jobtitle' | 'email';

export type RegionDetailsFields =
    | 'recovery_dashboard___coming_soon_region_id'
    | 'recovery_dashboard_updates___region_id'
    | 'recovery__add_district___state'
    | 'recovery__add_region___region_type'
    | 'recovery__add_district___district';

export type WidgetDetailsFields = 'recovery__download_widget___section';

export const allStates = [
    'Alabama',
    'Arkansas',
    'Arizona',
    'California',
    'Colorado',
    'Connecticut',
    'District of Columbia',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Iowa',
    'Idaho',
    'Illinois',
    'Indiana',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Massachusetts',
    'Maryland',
    'Maine',
    'Michigan',
    'Minnesota',
    'Missouri',
    'Mississippi',
    'Montana',
    'North Carolina',
    'North Dakota',
    'Nebraska',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'Nevada',
    'New York',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Virginia',
    'Vermont',
    'Washington',
    'Wisconsin',
    'West Virginia',
    'Wyoming',
    'Alaska',
];

export const regionTypes = ['County', 'City', 'Zip Code', 'BID'];

export const weeklyUpdatesFormId = '85271b19-cc1a-46d6-8a6b-936fa36da86e';
export const downloadReportFormId = 'd39bf344-51ef-41f5-9a5a-7d682d197173';
export const downloadWidgetFormId = '98fa558c-65b3-424d-8d6f-2f705d914d95';
export const missingRegionFormId = 'ee372be8-19d1-4637-9e8f-26d33a2e3130';
export const workplaceUpdateFormId = '1723f61e-a972-42b8-9737-72702c46e225';
export const comingSoonFormId = '86567180-6aad-474c-8231-314400544eb3';

export const formWidgetsImages: { [id in WidgetIDs]?: string } = {
    'foot-traffic-recovery-widget': footTrafficPreview,
    'recovery-map-widget': recoveryMapPreview,
    'retail-recovery-widget': retailPreview,
    'tourism-recovery-widget': tourismPreview,
    'zipcode-recovery-map-widget': zipcodesPreview,
};

export const formWidgetsNames: { [id in WidgetIDs]?: string } = {
    'foot-traffic-recovery-widget': 'Foot Traffic Recovery',
    'recovery-map-widget': 'Foot-Traffic Recovery by {type}',
    'retail-recovery-widget': 'Retail Visits Recovery',
    'tourism-recovery-widget': 'Tourism Visits Recovery',
    'zipcode-recovery-map-widget': 'Recovery by Zip Code',
};
